import React from "react";
import "./App.css";
import Main from "./containers/Main";
import ScrollToTop from "./components/scrollToTop/ScrollToTop";

function App() {
  return (
      <div className="App">
        <Main/>
        <ScrollToTop/>
      </div>
  );
}

export default App;
